import React, {useContext, useEffect, useState} from 'react';
import {withRouter} from 'react-router-dom'
import UsuarioForm from '../../../components/usuario/usuarioForm';
import {cadastrarUsuario, verificarUsuarioJaCadastrado} from '../../../services/usuario/UsuarioService';
import {AppContext} from '../../../components/shared/context';

const ConcluirCadastro = (props) => {
  const { keycloak } = useContext(AppContext);
  const { history } = props;
  const { sub } = keycloak.tokenParsed;

  const handleSubmit = async (form, convidado) => {
    let response;

    response = await cadastrarUsuario(form);

    if (response && response.status === 200) {
      if (convidado) {
        history.push('/reunioes')
      } else {
        history.push('/sucesso')
      }
      window.location.reload();
    }
  };

  const [cadastrado, setCadastrado] = useState(false);
  useEffect(() => {
    verificarUsuarioJaCadastrado(sub).then((response) => {
      if (response && response.status === 200) {
        const { data } = response;
        const { cadastrado } = data;
        setCadastrado(cadastrado);
      }
    })
  }, [])

  if (cadastrado) {
    history.push('/reunioes')
  } else {
    return (<UsuarioForm tipo="cadastrar" onSubmit={handleSubmit} labelBotao="Concluir Cadastro" />)
  }

  return null;
};

export default withRouter(ConcluirCadastro);
